module.exports = __webpack_public_path__ + "vue/img/ai-write.2fdfbe95.png";